import client from './client';

export interface FunnelStats {
    views: number;
    likes: number;
    orders: number;
}

export interface RetentionStats {
    newCustomers: number;
    returningCustomers: number;
}

export interface ProductPerformance {
    id: string;
    name: string;
    sales: number;
    views: number;
    likes: number;
    category: string;
}

export const getFunnelStats = async (sellerId?: string): Promise<FunnelStats> => {
    const response = await client.get('growth/funnel', { params: { sellerId } });
    return response.data;
};

export const getRetentionStats = async (sellerId?: string): Promise<RetentionStats> => {
    const response = await client.get('growth/retention', { params: { sellerId } });
    return response.data;
};

export const getProductPerformance = async (sellerId?: string): Promise<ProductPerformance[]> => {
    const response = await client.get('growth/product-performance', { params: { sellerId } });
    return response.data;
};
